class FarmService {
  /**
   * Asigna la lista de archivos en el almacenamiento temporal a la lista de archivos en la finca
   *
   * @param {object} farmInfo - La información de la finca
   * @param {number} userId de usuario: el ID de usuario
   * @param {boolean} [addName=true] - Si se debe agregar el nombre de la finca al nombre del archivo
   * @returns { * @returns {Promise<string[]>} La lista de nombres de archivos
   */
  static async map(farmInfo, userId, addName = true) {
    let namesFiles = [];
    let lfTmp = JSON.parse(localStorage.getItem('listFiles'));

    for (const key in lfTmp) {
      if (Object.hasOwnProperty.call(lfTmp, key)) {
        let path = '';
        const element = lfTmp[key];
        if (sessionStorage.getItem('editForm')) {
          if (farmInfo.other_values.includes(key)) {
            if (element && element[0]) {
              if (!element[0].editFile || element.length == 0) {
                path =
                  `${farmInfo.id}/${key}` +
                  (addName ? `|${farmInfo.name}` : ``);
                namesFiles.push(path);
              } else {
                if (element.length > 0) {
                  path =
                    `tmp/${userId}/${key}` +
                    (addName ? `|${farmInfo.name}` : ``);
                  namesFiles.push(path);
                }
              }
            } else {
              path =
                `tmp/${userId}/${key}` + (addName ? `|${farmInfo.name}` : ``);
              namesFiles.push(path);
            }
          }
        } else {
          if (element && element[0] && element.length > 0) {
            path =
              `tmp/${userId}/${key}` + (addName ? `|${farmInfo.name}` : ``);
            namesFiles.push(path);
          }
        }
      }
    }

    return namesFiles;
  }
}

export default FarmService;
